module.exports = __webpack_public_path__ + "static/media/loading.7259b035.gif";